<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="900">
    <kendo-dialog-titlebar>
        <h3>{{ isNew ? addTitle : editTitle }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="editForm">
        <kendo-tabstrip #tabstrip>
            <kendo-tabstrip-tab title="{{tabName}}" [selected]="true">
                <ng-template kendoTabContent>
                    <div class="pt-3 pl-3 pr-3">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-12">
                                    <label class="k-form-field w-100">
                                        <span class="k-text-uppercase dark">
                                            {{'NAME' | translate}} *
                                        </span>
                                        <input id="name" kendoTextBox formControlName="name" maxlength="100" />
                                        <div class="k-tooltip k-tooltip-validation" role="alert"
                                            *ngIf="name.hasError('required') && name.touched">
                                            {{'REQUIRED-NAME' | translate}}
                                        </div>
                                        <div class="k-tooltip k-tooltip-validation" role="alert"
                                            *ngIf="name.hasError('nameExists')">
                                            {{nameAlreadyExists}}
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="k-text-uppercase dark mr-2" for="active">{{ 'ENABLED' | translate
                                }}</label>
                            <kendo-switch formControlName="active" onLabel="{{'YES' | translate }}"
                                offLabel="{{'NO' | translate }}">
                            </kendo-switch>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="{{ 'PAYER-DETAILS' | translate }}" *ngIf="revenueManager">
                <ng-template kendoTabContent>
                    <div class="pt-3 pl-3 pr-3">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-12">
                                    <label class="k-form-field w-100">
                                        <span class="k-text-uppercase dark">
                                            {{'CONTACT-NAME' | translate}}
                                        </span>
                                        <input id="contactName" kendoTextBox formControlName="contactName"
                                            maxlength="255" />
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="k-form-field w-100">
                                        <span class="k-text-uppercase dark">
                                            <i class="fas fa-mobile-android-alt fa-fw"></i> {{'CONTACT-PHONE' |
                                            translate}}
                                        </span>
                                        <kendo-maskedtextbox [mask]="phoneNumberMask" id="contactPhone"
                                            formControlName="contactPhone">
                                        </kendo-maskedtextbox>
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="k-form-field w-100">
                                        <span class="k-text-uppercase dark">
                                            <i class="fas fa-envelope fa-fw"></i> {{'CONTACT-EMAIL' | translate}}
                                        </span>
                                        <input id="contactEmail" kendoTextBox formControlName="contactEmail" email
                                            maxlength="255" />
                                        <div class="k-tooltip k-tooltip-validation" role="alert"
                                            *ngIf="contactEmail.invalid && contactEmail.touched && contactEmail.value">
                                            {{'WRONG-EMAIL-FORMAT' | translate}}
                                        </div>
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="k-form-field w-100">
                                        <span class="k-text-uppercase dark">
                                            <i (click)="openUrl()" [ngClass]="{'has-valid-url': isValidUrl()}"
                                                class="fas fa-link fa-fw"></i> {{'URL' |
                                            translate}}
                                        </span>
                                        <input id="url" kendoTextBox formControlName="url" class="w-100" />
                                        <div class="k-tooltip k-tooltip-validation" role="alert"
                                            *ngIf="!isValidUrl() && url.hasError('pattern') && url.touched">
                                            {{'INVALID-WWW' | translate}}
                                        </div>
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="k-form-field w-100">
                                        <span class="k-text-uppercase dark">
                                            {{'INVOICE-NUMBER-SUFFIX' | translate}} *
                                        </span>
                                        <input id="invoiceNumberSuffix" kendoTextBox
                                            formControlName="invoiceNumberSuffix" maxlength="10" />
                                        <div class="k-tooltip k-tooltip-validation" role="alert"
                                            *ngIf="invoiceNumberSuffix.hasError('required') && invoiceNumberSuffix.touched">
                                            {{'REQUIRED-INVOICE-NUMBER-SUFFIX' | translate}}
                                        </div>
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12" *ngIf="allFeeSchedules.length > 0">
                                    <label for="feeSchedules" class="k-form-field w-100">
                                        <span class="k-text-uppercase dark">
                                            {{'FEE-SCHEDULE' | translate}} *
                                        </span>
                                        <kendo-multiselect id="feeSchedules" [data]="feeSchedulesFiltered"
                                            formControlName="feeSchedules" [textField]="'displayName'"
                                            [filterable]="true" [valueField]="'id'"
                                            (filterChange)="filterFeeSchedules($event)" (close)="searchTerm=''"
                                            [autoClose]="true" [virtual]="virtualFeeSchedule">
                                            <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                                <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                    class="ellipsis-text">
                                                </span>
                                            </ng-template>
                                        </kendo-multiselect>
                                        <div class="k-tooltip k-tooltip-validation" role="alert"
                                            *ngIf="feeSchedules.hasError('required') && feeSchedules.touched">
                                            {{'REQUIRED-FEE-SCHEDULE' | translate}}
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
        </kendo-tabstrip>
        <div class="mt-3">* {{'REQUIRED-FIELDS' | translate}}</div>
    </form>

    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty"
            (click)="onSave($event)">{{ 'SAVE' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>